import React from "react";
import {
  Grid,
  createStyles,
  makeStyles,
  TextField,
} from "@material-ui/core";

import { Formik } from "formik";
import * as Yup from "yup";

import { POST_INSERT_COUNCIL } from "../../../services/options";
import { SelectApi } from "../../../Components/SelectsApi";
import { useSnackbar } from "notistack";
import api from "../../../services/Api";
import { ButtonSuccess } from "../../../Components/ButtonSuccess";
import DefaultModal, { DefaultModalActions, DefaultModalContent } from "../../../Components/DefaultModal";

const useStyles = makeStyles((theme) =>
createStyles({
  root: {
    display: "grid",
    [theme.breakpoints.up("xs")]: {width: 380, padding: theme.spacing(0, 1, 0, 1),},  
    [theme.breakpoints.up("sm")]: {width: 450, padding: theme.spacing(0, 1, 0, 1),},   
    [theme.breakpoints.up("md")]: {width: 500, padding: theme.spacing(0, 1, 0, 1),},  
    [theme.breakpoints.up("lg")]: {width: 500, padding: theme.spacing(0, 1, 0, 1),},  
    [theme.breakpoints.up("xl")]: {width: 550, padding: theme.spacing(0, 1, 0, 1),},  
  },
})
);

const initialValues = {
  name: "",
};

const validationSchema = Yup.object().shape({
  name: Yup.string().required("Obrigatório"),
});

export default function NewCouncil({open, setOpen, updateData }) {
  const { enqueueSnackbar } = useSnackbar();

  const submit = async (values, { setSubmitting }) => {
    const buffer = {
      name: values.name,
    }
    await api(POST_INSERT_COUNCIL(buffer)).then(r=>{
      const {data} = r;
      if (data.status === "success"){
        updateData();
        setSubmitting(false);
        enqueueSnackbar("Vereador criado com sucesso", { variant: "success" });
        setOpen(false);
      }else{
        setSubmitting(false);
        enqueueSnackbar("Erro ao criar vereador", { variant: "error" });
      }
    }).catch(e=>{
      setSubmitting(false);
      enqueueSnackbar(`Erro ${e.message}`, { variant: "error" });
    })
  };

  return (
    <DefaultModal open={open} handleClose={() => setOpen(false)} title="Novo Vereador">
      <DefaultModalContent>
        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={submit}>
          {(props) => <Forms {...props} />}
        </Formik>
      </DefaultModalContent>
    </DefaultModal>
  );
}

const Forms = (props) => {
  const classes = useStyles();
  const {
    values,
    touched,
    errors,
    isSubmitting,
    handleChange,
    handleBlur,
    handleSubmit,
    setFieldValue,
  } = props;

  return (
    <form onSubmit={handleSubmit} noValidate>
      <DefaultModalContent dividers>
        <Grid container className={classes.root} spacing={3}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            multiline
            maxRows={5}
            variant="outlined"
            size="small"
            id="name"
            label="Nome"
            name="name"
            autoFocus
            inputProps={{ autoComplete: "off" }}
            onChange={handleChange}
            value={values.name}
            error={touched.name && Boolean(errors.name)}
            helperText={touched.name && errors.name}
          />
        </Grid>
      </Grid>
      </DefaultModalContent>
      <DefaultModalActions>
        <ButtonSuccess type="submit" disabled={isSubmitting}>
          Salvar
        </ButtonSuccess>
      </DefaultModalActions>
    </form>
  );
};
